export const SecurityAndPrivacyBoxLink = {
  padding: '10px',
  borderBottom: '1px solid #E9E9E9',
  cursor: 'pointer',
  transition: 'all .3s ease',
  '&:hover': {
    background: '#f9f9f9'
  }
};
